module.exports = __webpack_public_path__ + "img/donkey-kong.e80ce918.png";